export default {
  data() {
    return { loading: false, error: null, list: null }
  },

  watch: {
    '$route.query.q'() {
      const params = this.$route.query
      this.fetchData(params)
    },
  },

  created() {
    const params = this.$route.query
    this.fetchData(params)
  },
}
